import LilZDancing from '../assets/gifs/Lil_Z_Dancing.gif';
import DespondentSigh from '../assets/gifs/Despondent Sigh.gif';
import Excercise from '../assets/gifs/Excircise.gif';
import TearfulEyes from '../assets/gifs/Tearfuleyes.gif';
import MoonWalk from '../assets/gifs/Moon_walk.gif';
import MrZSad from '../assets/gifs/MrZ_Sad.gif';
import MrZWine from '../assets/gifs/MrZ_Wine.gif';
import MrZCrying from '../assets/gifs/MrZ_Crying.gif';
import VictoryFins from '../assets/gifs/VictoryFins.gif';
import ConfettiCelebration from '../assets/gifs/Confetti Celebration.gif';
import SlumpedShoulder from '../assets/gifs/SlumpedShoulder.gif';
import Rotation2 from '../assets/gifs/Rotation2.gif';
import Jumping from '../assets/gifs/Jumping.gif';
import MrZSexyDancin from '../assets/gifs/MrZ_Sexy_Dancin.gif';
import Dancing from '../assets/gifs/Dancing.gif';
import StarShower from '../assets/gifs/Star Shower.gif';

const getGif = ({ fromStage, fromQuest, fromChallenge, stageId, level, isCorrect }) => {
    if (fromStage) {
        if (stageId >= 1 && stageId <= 3) {            
            return isCorrect ? LilZDancing : DespondentSigh;
        } else if (stageId >= 4 && stageId <= 5) {
            return isCorrect ? Excercise : TearfulEyes;
        } else if (stageId >= 6 && stageId <= 8) {
            return isCorrect ? MoonWalk : MrZSad;
        } else if (stageId >= 9 && stageId <= 10) {
            return isCorrect ? MrZWine : MrZCrying;
        } else if (stageId >= 11 && stageId <= 13) {
            return isCorrect ? VictoryFins : TearfulEyes;
        } else if (stageId >= 14 && stageId <= 15) {
            return isCorrect ? ConfettiCelebration : SlumpedShoulder;
        } else {
            return Rotation2;
        }
    } else if (fromQuest) {
        if (level === "easy") {
            return isCorrect ? Jumping : DespondentSigh;
        } else if (level === "medium") {
            return isCorrect ? MrZSexyDancin : MrZSad;
        } else if (level === "hard") {
            return isCorrect ? Dancing : TearfulEyes;
        } else {
            return Rotation2;
        }
    } else if (fromChallenge) {
        const randomChallengeGifs = [StarShower, MrZWine, MrZWine];
        const randomIndex = Math.floor(Math.random() * randomChallengeGifs.length);
        return randomChallengeGifs[randomIndex];
    } else {
        return Rotation2;
    }
};

export default getGif;